import React, { Fragment } from 'react';
import { string, func } from "prop-types";
import { Grid } from "@material-ui/core";
import { isEmpty, forEach } from 'lodash';
import { TagBlue, SmallLinkButton } from '@worthy-npm/clarity';
import { reject } from 'lodash';

import { LOCAL_STORAGE_PREFIX, RDStorage, FILTERS_PER_TYPE } from './filtersData';
import { FILTER_OPTIONS } from '../filters/filter_constants_and_helpers.jsx.erb';

class RecentDealsFilters extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            changedFilters: {},
            hidden: false,
        };

        this.setFilters = this.setFilters.bind(this);
        this.renderTagLine = this.renderTagLine.bind(this);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        /*
        *  This solution added cause i need somehow update filters (in order to initialize all filters). And make componnet all data from filters
        * So i found this when we hiding and again mounting filters. with setTimeout. Not best solution but is working.
        * This is only for items
        * */

        const itemsWithSameFilters = ['necklaces', 'earrings', 'bracelets', 'rings', 'loose-diamonds']; // items which has the same filters and didn`t update filters when change itemTpe in parent component

        if (prevProps.itemType !== this.props.itemType && itemsWithSameFilters.includes(this.props.itemType) && prevProps.itemType !== 'watches') {
            this.setState({
                hidden: true,
            });

            setTimeout(() => this.setState({ hidden: false }), 0);
        }
    }

    setFilters(filterName, newValue, isDefault, xClicked, tagName) { // tagName - [string]
        /*Handle case when for brand filter where we need */
        /*
        *  Did this step (operations) here cause on brand_filter it cause issue with the tags. And this callback are called from base_filter
        *  In this case we preparing data for server.
        * */
        if (filterName === 'jewelry_brands') { // prepare filter data which will be send to server with not_in and and in values
            const getNotInFilters = () => FILTER_OPTIONS.jewelry_brands.map(o => o.id);

            newValue.is && newValue.is.length >= 1 ? newValue.is = [null] : delete newValue.is; // in order to handle NULL records in bd
            newValue.not_in && newValue.not_in.length >= 1 ? newValue.not_in = getNotInFilters() : delete newValue.not_in;
        }

        this.props.onChangeFilter({ detail: { // for parent RecentDealsContainer component
                itemType: this.props.itemType,
                filterName: filterName,
                data: { ...newValue },
                tagNames: tagName,
                requiredFilters: FILTERS_PER_TYPE[this.props.itemType]
            }});


        let { changedFilters } = this.state;
        const { itemType } = this.props;

        if (!changedFilters[itemType]) {
            changedFilters[itemType] = {};
        }

        const filters = changedFilters[itemType];

        if ( isDefault ) {
            delete filters[filterName]
        } else {
            filters[filterName] = newValue;
            filters[filterName].xClicked = xClicked;
            filters[filterName].tagName = tagName;
        }

        this.setState({ changedFilters })
    }

    renderTagLine() {
        const { changedFilters } = this.state;

        const appliedFiltersPerType = changedFilters[this.props.itemType];

        if (isEmpty(appliedFiltersPerType)) {
            return
        }

        return (
            <div className='tags-container'>
                {
                    Object.keys(appliedFiltersPerType).map(
                        (key) => appliedFiltersPerType[key].tagName.map(
                            tag => (
                                <span key={key+tag}  style={{ display: 'inline-block', margin: '0 10px 10px 0' }}>
                                    <TagBlue text={tag} onClose={() => appliedFiltersPerType[key].xClicked(tag)} />
                                </span>
                            )
                        ))
                }
                <SmallLinkButton
                    text="Clear all"
                    click={() => forEach(appliedFiltersPerType, (key) => key.xClicked())}
                    overrideCSS={{ backgroundColor: '#F2F0EE', font: '400 16px Uncut Sans'}}
                />
        </div>)
    }

    render() {
        const { itemType } = this.props;
        const { changedFilters } = this.state;
        const appliedFiltersPerType = changedFilters[this.props.itemType];

        if ( !FILTERS_PER_TYPE[itemType] ) {
            return null
        }

        return (
            <Fragment>
                <Grid container spacing={3} className={`filters-desktop ${this.props.isMobileFilterShown ? 'opened' : ''}`}>
                        {
                            !this.state.hidden && FILTERS_PER_TYPE[itemType].map((e, i) => (
                                <Grid item lg={4} md={4} key={i}>
                                    {
                                        React.createElement(e,{
                                            visible: true,
                                            itemType: itemType,
                                            route: "recent_deals_"+ itemType,
                                            setFilters: this.setFilters,
                                            storagePrefix: LOCAL_STORAGE_PREFIX,
                                            storage: RDStorage,
                                            key: i,
                                            itemFilters: this.props.itemFilters
                                        })
                                    }
                                </Grid>))
                        }
                </Grid>

                { !isEmpty(appliedFiltersPerType) &&
                    <Grid container style={{ margin: '0 0 20px' }}>
                        <Grid item>
                            {this.renderTagLine()}
                        </Grid>
                    </Grid>
                }
            </Fragment>
        )
    }
}

RecentDealsFilters.propTypes = {
    itemType: string,
    onChangeFilter: func,
};

export default RecentDealsFilters;
